import { EventEmitter, Injectable, Output } from '@angular/core';
import { ApplicationHttpClient } from '../../components/shared/http/application-http-client';
import { JwtLegFiClaims } from '../auth/jwt-legfi-claims.model';
import { LegFiJwtService } from '../auth/legfi-jwt.service';
import { Observable } from 'rxjs';
import { Routes } from '../../config/routes';
import { PayabliBoardingSubmission } from '../../models/entities/payabli-boarding-submission';
import { map } from 'rxjs/operators';
import { Payable } from '../../models/entities/payable';

@Injectable({
    providedIn: 'root',
})
export class PayabliService
{
    @Output() applicationDeleted = new EventEmitter<void>();
    private _http: ApplicationHttpClient;

    constructor(_http: ApplicationHttpClient) {
        this._http = _http;
    }

    public initiatePayabliApplication(): Observable<PayabliBoardingSubmission> {
        const jwt: JwtLegFiClaims = LegFiJwtService.read();
        if (jwt === null) {
            return this._http.redirectAndThrow401Observable();
        }
        const url = Routes.MakeLegFiCoreUrl('/payables/application');

        return this._http.post(url, JSON.stringify({}))
                .pipe(map((res: PayabliBoardingSubmission) => {
                    return new PayabliBoardingSubmission(res);
                }
        ));
    }

    public getPayabliApplication(): Observable<PayabliBoardingSubmission> {
        const jwt: JwtLegFiClaims = LegFiJwtService.read();
        if (jwt === null) {
            return this._http.redirectAndThrow401Observable();
        }
        const url = Routes.MakeLegFiCoreUrl('/payables/application');

        return this._http.get(url);
    }

    public deletePayabliApplication(payabliApplication): Observable<void> {
        const jwt: JwtLegFiClaims = LegFiJwtService.read();
        if (jwt === null) {
            return this._http.redirectAndThrow401Observable();
        }
        const url = Routes.MakeLegFiCoreUrl('/payables/application/' + payabliApplication.id);

        return this._http.delete(url).pipe(
                map(() => {
                    this.applicationDeleted.emit();
                }));
    }

    public getOcrResults(
            uploadedFileId: number,
            inboundEmailId: number = null,
            payableId: number = null,
    ): Observable<Object> {
        const jwt: JwtLegFiClaims = LegFiJwtService.read();
        if (jwt === null) {
            return this._http.redirectAndThrow401Observable();
        }

        const url = Routes.MakeLegFiCoreUrl('/payables/ocr');

        return this._http.post(url, JSON.stringify({
            uploadedFileId: uploadedFileId,
            inboundEmailId: inboundEmailId,
            payableId: payableId,
            organizationId: jwt.orgId,
        }));
    }

    /**
     * Polls for the result of the asynchronous OCR job kicked off by getOcrResults (SD-7269).
     * Returns { ocrStatus: 'pending' | 'completed' | 'failed', ... } so the caller can poll
     * until the extraction completes or fails.
     */
    public getOcrStatus(uploadedFileId: number): Observable<Object> {
        const jwt: JwtLegFiClaims = LegFiJwtService.read();
        if (jwt === null) {
            return this._http.redirectAndThrow401Observable();
        }

        const url = Routes.MakeLegFiCoreUrl(
            '/payables/ocr/status?uploadedFileId=' + uploadedFileId + '&organizationId=' + jwt.orgId,
        );

        return this._http.get(url);
    }
}
